const getHongKongTimestamp = () => {
  const now = new Date().toLocaleString("en-GB", {
    timeZone: "Asia/Hong_Kong",
    hour12: false,
  });
  const [date, time] = now.split(", ");
  const formattedDate = date.split("/").reverse().join("-");
  const formattedTime = time.replace(/:/g, "-");
  return `${formattedDate}_${formattedTime}`;
};

export default getHongKongTimestamp;
